import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import * as gridCss from "@redotech/redo-web/grid.module.css";
import classNames from "classnames";
import { memo } from "react";
import { ImsGeneralForm } from "./general";

export const OrderSyncCard = memo(function OrderSyncCard({
  input,
}: {
  input: ImsGeneralForm;
}) {
  const { orderSyncTemporal } = input.inputs;

  return (
    <Card title="Order Sync">
      <section className={gridCss.grid}>
        <div className={gridCss.span12}>
          <div className={gridCss.grid}>
            <div className={classNames(gridCss.span6L, gridCss.span12)}>
              <RedoToggle
                description="Use Temporal workflows for order sync (improved reliability)"
                label="Order Sync Temporal"
                setValue={(value) => orderSyncTemporal.setValue(value)}
                size="sm"
                value={orderSyncTemporal.value ?? false}
              />
            </div>
          </div>
        </div>
      </section>
    </Card>
  );
});
